/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BBookPairDto } from './bBookPairDto';

/**
 * B book asset settings Dto.
 */
export interface BBookAssetStatusDto {
  assetId: number;
  maxSize: number;
  maxPosition: number;
  maxLoss: number;
  autoClosePositionOnMaxLoss: boolean;
  positionQty: number;
  positionVolume: number;
  openPnl: number;
  closedPnl: number;
  disabledDueLoss: boolean;
  tradeCount: number;
  tradeVolume: number;
  autoReducePosition: boolean;
  linkedPairs: Array<BBookPairDto>;
}
